import { render, staticRenderFns } from "./ApplicationUpdate.vue?vue&type=template&id=1f2fc96d&scoped=true"
import script from "./ApplicationUpdate.vue?vue&type=script&lang=js"
export * from "./ApplicationUpdate.vue?vue&type=script&lang=js"
import style0 from "./ApplicationUpdate.vue?vue&type=style&index=0&id=1f2fc96d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2fc96d",
  null
  
)

export default component.exports